var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalreach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_355_4714)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.65 34.4099C29.22 34.4099 28.79 34.3199 28.44 34.1499L23.19 31.5199C22.89 31.3699 22.3 31.3799 22.01 31.5499L19.65 32.8999C18.63 33.4799 17.58 33.5599 16.79 33.0899C15.99 32.6299 15.54 31.6899 15.54 30.5099V20.7899C15.54 19.8799 16.14 18.8499 16.93 18.3999L21.26 15.9199C21.99 15.4999 23.1 15.4699 23.85 15.8499L29.1 18.4799C29.4 18.6299 29.98 18.6099 30.28 18.4499L32.63 17.1099C33.65 16.5299 34.7 16.4499 35.49 16.9199C36.29 17.3799 36.74 18.3199 36.74 19.4999V29.2299C36.74 30.1399 36.14 31.1699 35.35 31.6199L31.02 34.0999C30.64 34.2999 30.14 34.4099 29.65 34.4099ZM22.64 29.9199C23.07 29.9199 23.5 30.0099 23.85 30.1799L29.1 32.8099C29.4 32.9599 29.98 32.9399 30.28 32.7799L34.61 30.2999C34.93 30.1199 35.24 29.5799 35.24 29.2199V19.4899C35.24 18.8599 35.06 18.3899 34.73 18.2099C34.41 18.0299 33.91 18.0999 33.37 18.4099L31.02 19.7499C30.29 20.1699 29.18 20.1999 28.43 19.8199L23.18 17.1899C22.88 17.0399 22.3 17.0599 22 17.2199L17.67 19.6999C17.35 19.8799 17.04 20.4199 17.04 20.7899V30.5199C17.04 31.1499 17.22 31.6199 17.54 31.7999C17.86 31.9899 18.36 31.9099 18.91 31.5999L21.26 30.2599C21.65 30.0299 22.15 29.9199 22.64 29.9199Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5601 30.75C22.1501 30.75 21.8101 30.41 21.8101 30V17C21.8101 16.59 22.1501 16.25 22.5601 16.25C22.9701 16.25 23.3101 16.59 23.3101 17V30C23.3101 30.41 22.9701 30.75 22.5601 30.75Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.73 33.7501C29.32 33.7501 28.98 33.4101 28.98 33.0001V19.6201C28.98 19.2101 29.32 18.8701 29.73 18.8701C30.14 18.8701 30.48 19.2101 30.48 19.6201V33.0001C30.48 33.4101 30.14 33.7501 29.73 33.7501Z",
    fill: "#292D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_355_4714",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_355_4714"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_355_4714",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalreach);
export default __webpack_public_path__ + "static/media/globalreach.9112e6d4a1da6e8ecc53867138ae7c6f.svg";
export { ForwardRef as ReactComponent };